// FeatureSVGs.js

import React from 'react';

// --- Themes and SVGDefs remain the same ---
const themes = {
    extract: { // blue
        primaryGradient: 'url(#extractPrimaryGradient)',
        secondaryGradient: 'url(#extractSecondaryGradient)',
        accentGradient: 'url(#extractAccentGradient)',
        glowFilter: 'url(#extractGlow)',
        primaryColor: '#3b82f6',
        secondaryColor: '#60a5fa',
        accentColor: '#dbeafe',
        darkColor: '#1e40af'
    },
    refine: { // indigo
        primaryGradient: 'url(#refinePrimaryGradient)',
        secondaryGradient: 'url(#refineSecondaryGradient)',
        accentGradient: 'url(#refineAccentGradient)',
        glowFilter: 'url(#refineGlow)',
        primaryColor: '#6366f1',
        secondaryColor: '#818cf8',
        accentColor: '#e0e7ff',
        darkColor: '#4338ca'
    },
    fuel: { // amber
        primaryGradient: 'url(#fuelPrimaryGradient)',
        secondaryGradient: 'url(#fuelSecondaryGradient)',
        accentGradient: 'url(#fuelAccentGradient)',
        glowFilter: 'url(#fuelGlow)',
        primaryColor: '#f59e0b',
        secondaryColor: '#fbbf24',
        accentColor: '#fef3c7',
        darkColor: '#b45309'
    }
};

const SVGDefs = () => (
    <defs>
        {/* Extract Gradients */}
        <linearGradient id="extractPrimaryGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={themes.extract.primaryColor} />
            <stop offset="100%" stopColor={themes.extract.darkColor} />
        </linearGradient>
        <radialGradient id="extractSecondaryGradient" cx="50%" cy="50%" r="70%">
            <stop offset="0%" stopColor={themes.extract.secondaryColor} stopOpacity="1" />
            <stop offset="100%" stopColor={themes.extract.primaryColor} stopOpacity="0.7" />
        </radialGradient>
        <linearGradient id="extractAccentGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={themes.extract.accentColor} stopOpacity="0.9" />
            <stop offset="100%" stopColor={themes.extract.secondaryColor} stopOpacity="0.7" />
        </linearGradient>
        <filter id="extractGlow" x="-30%" y="-30%" width="160%" height="160%">
            <feGaussianBlur stdDeviation="4" result="blur" />
            <feFlood floodColor={themes.extract.primaryColor} floodOpacity="0.6" result="color" />
            <feComposite in="color" in2="blur" operator="in" result="glow" />
            <feMerge> <feMergeNode in="glow" /> <feMergeNode in="SourceGraphic" /> </feMerge>
        </filter>

        {/* Refine Gradients */}
        <linearGradient id="refinePrimaryGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={themes.refine.primaryColor} />
            <stop offset="100%" stopColor={themes.refine.darkColor} />
        </linearGradient>
        <radialGradient id="refineSecondaryGradient" cx="50%" cy="50%" r="70%">
            <stop offset="0%" stopColor={themes.refine.secondaryColor} stopOpacity="1" />
            <stop offset="100%" stopColor={themes.refine.primaryColor} stopOpacity="0.7" />
        </radialGradient>
        <linearGradient id="refineAccentGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={themes.refine.accentColor} stopOpacity="0.9" />
            <stop offset="100%" stopColor={themes.refine.secondaryColor} stopOpacity="0.7" />
        </linearGradient>
        <filter id="refineGlow" x="-30%" y="-30%" width="160%" height="160%">
            <feGaussianBlur stdDeviation="4" result="blur" />
            <feFlood floodColor={themes.refine.primaryColor} floodOpacity="0.6" result="color" />
            <feComposite in="color" in2="blur" operator="in" result="glow" />
            <feMerge> <feMergeNode in="glow" /> <feMergeNode in="SourceGraphic" /> </feMerge>
        </filter>

        {/* Fuel Gradients */}
        <linearGradient id="fuelPrimaryGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={themes.fuel.primaryColor} />
            <stop offset="100%" stopColor={themes.fuel.darkColor} />
        </linearGradient>
        <radialGradient id="fuelSecondaryGradient" cx="50%" cy="50%" r="70%">
            <stop offset="0%" stopColor={themes.fuel.secondaryColor} stopOpacity="1" />
            <stop offset="100%" stopColor={themes.fuel.primaryColor} stopOpacity="0.7" />
        </radialGradient>
        <linearGradient id="fuelAccentGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={themes.fuel.accentColor} stopOpacity="0.9" />
            <stop offset="100%" stopColor={themes.fuel.secondaryColor} stopOpacity="0.7" />
        </linearGradient>
        <filter id="fuelGlow" x="-30%" y="-30%" width="160%" height="160%">
            <feGaussianBlur stdDeviation="4" result="blur" />
            <feFlood floodColor={themes.fuel.primaryColor} floodOpacity="0.6" result="color" />
            <feComposite in="color" in2="blur" operator="in" result="glow" />
            <feMerge> <feMergeNode in="glow" /> <feMergeNode in="SourceGraphic" /> </feMerge>
        </filter>

        {/* Shared patterns/elements */}
        <pattern id="dotPattern" patternUnits="userSpaceOnUse" width="15" height="15">
            <circle cx="2" cy="2" r="1" fill="currentColor" opacity="0.3" />
        </pattern>
        <pattern id="linePattern" patternUnits="userSpaceOnUse" width="10" height="10">
            <path d="M-1,1 l2,-2 M0,10 l10,-10 M9,11 l2,-2" stroke="currentColor" strokeWidth="0.5" opacity="0.3" />
        </pattern>
    </defs>
);


// --- Simplified SVG Components ---

// FindItSVG (Extract): Abstract scanner finding data points - THIS ONE IS GOOD
export const FindItSVG = () => (
    <svg viewBox="0 0 200 150" preserveAspectRatio="xMidYMid meet" className="w-full h-auto overflow-visible">
        <SVGDefs />
        <g className="extract-visualization" filter={themes.extract.glowFilter}>
            {/* Background data field */}
            <rect x="-10" y="-10" width="220" height="170" fill={themes.extract.darkColor} opacity="0.2" rx="10" />
            <rect x="-10" y="-10" width="220" height="170" fill="url(#dotPattern)" stroke={themes.extract.secondaryColor} strokeWidth="0.5" strokeOpacity="0.3" rx="10" className="text-blue-400" />

            {/* Central scanning element */}
            <circle cx="100" cy="75" r="40" fill={themes.extract.secondaryGradient} opacity="0.6" />

            {/* Scanning Rings */}
            {[1, 2].map((i) => (
                <circle key={i} cx="100" cy="75" r={15 + i * 20} fill="none" stroke={themes.extract.accentGradient} strokeWidth="1.5" strokeDasharray="5 5" opacity="0.8">
                    <animate attributeName="r" values={`${15 + i * 20};${15 + i * 20 + 30};${15 + i * 20}`} dur={`${3 + i * 1}s`} repeatCount="indefinite" />
                    <animate attributeName="opacity" values="0.8;0;0.8" dur={`${3 + i * 1}s`} repeatCount="indefinite" />
                </circle>
            ))}

            {/* Data Points Being Found */}
            {[
                { cx: 50, cy: 40, r: 4, delay: "0s" },
                { cx: 150, cy: 60, r: 5, delay: "0.5s" },
                { cx: 70, cy: 110, r: 3, delay: "1s" },
                { cx: 130, cy: 100, r: 4, delay: "1.5s" }
            ].map((point, i) => (
                <circle key={i} cx={point.cx} cy={point.cy} r={point.r} fill={themes.extract.accentColor} opacity="0">
                    <animate attributeName="opacity" values="0; 1; 1; 0" dur="2.5s" begin={point.delay} repeatCount="indefinite" />
                    <animate attributeName="r" values={`${point.r}; ${point.r * 1.5}; ${point.r}`} dur="2.5s" begin={point.delay} repeatCount="indefinite" />
                </circle>
            ))}
            {/* Scanner line */}
            <line x1="100" y1="75" x2="100" y2="25" stroke={themes.extract.accentColor} strokeWidth="2" strokeLinecap="round">
                <animateTransform attributeName="transform" type="rotate" from="0 100 75" to="360 100 75" dur="4s" repeatCount="indefinite" />
            </line>
        </g>
    </svg>
);


// BuildItSVG (Refine): Filtering Layers Concept
export const BuildItSVG = () => (
    <svg viewBox="0 0 200 150" preserveAspectRatio="xMidYMid meet" className="w-full h-auto overflow-visible">
        <SVGDefs />
        <g className="refine-visualization">
            {/* Background */}
            <rect x="0" y="0" width="200" height="150" fill={themes.refine.darkColor} opacity="0.1" rx="5" />

            {/* Filter Layers */}
            {[0, 1, 2].map(i => (
                <g key={i} transform={`translate(${60 + i * 25}, 25)`}>
                    <rect
                        x="0" y="0" width="15" height="100"
                        fill={themes.refine.primaryGradient}
                        stroke={themes.refine.secondaryColor}
                        strokeWidth="0.5"
                        rx="3"
                        opacity={0.4 + i * 0.1} // Layers get slightly more opaque
                        filter={themes.refine.glowFilter}
                    >
                        {/* Subtle pattern */}
                        <rect x="0" y="0" width="15" height="100" fill="url(#linePattern)" className="text-indigo-300" opacity="0.5" />
                    </rect>
                </g>
            ))}

            {/* Particle Flow Path (Invisible) */}
            <path id="refinePathFlow" d="M 10 75 H 190" fill="none" />

            {/* Flowing Particles */}
            {[...Array(10)].map((_, i) => (
                <circle key={i} r="3.5" fill={themes.refine.secondaryColor} opacity="0.8">
                    {/* Move along path */}
                    <animateMotion dur={`${2 + Math.random() * 1}s`} begin={`${i * 0.15}s`} repeatCount="indefinite" path="M 10 75 H 190" />

                    {/* Change color slightly as it passes filters */}
                    <animate attributeName="fill"
                        values={`${themes.refine.secondaryColor}; ${themes.refine.secondaryColor}; ${themes.refine.primaryColor}; ${themes.refine.primaryColor}; ${themes.refine.accentColor}; ${themes.refine.accentColor}`}
                        keyTimes="0; 0.3; 0.45; 0.6; 0.75; 1" // Timing based on filter positions
                        dur={`${2 + Math.random() * 1}s`}
                        begin={`${i * 0.15}s`}
                        repeatCount="indefinite"
                    />
                    {/* Fade out at the end */}
                    <animate attributeName="opacity"
                        values="0.8; 0.8; 0"
                        keyTimes="0; 0.9; 1"
                        dur={`${2 + Math.random() * 1}s`}
                        begin={`${i * 0.15}s`}
                        repeatCount="indefinite"
                    />
                </circle>
            ))}
        </g>
    </svg>
);


// UseItSVG (Fuel): Filling Gauge & Radiating Energy Concept
export const UseItSVG = () => {
    const gaugeRadius = 50;
    const circumference = 2 * Math.PI * gaugeRadius;
    // Let's aim for ~85% full for the animation target
    const strokeEnd = circumference * 0.15; // Remaining gap
    const strokeStart = circumference; // Start empty

    return (
        <svg viewBox="0 0 200 150" preserveAspectRatio="xMidYMid meet" className="w-full h-auto overflow-visible">
            <SVGDefs />
            <g className="fuel-visualization" transform="translate(0 5)"> {/* Shift down slightly */}
                {/* Subtle background radial */}
                <circle cx="100" cy="70" r="70" fill={themes.fuel.darkColor} opacity="0.15" />

                {/* Gauge Background Track */}
                <circle
                    cx="100" cy="70" r={gaugeRadius}
                    fill="none"
                    stroke={themes.fuel.darkColor} // Darker track
                    strokeWidth="10"
                    strokeLinecap="round"
                    opacity="0.5"
                />

                {/* Filling Gauge Arc */}
                <circle
                    cx="100" cy="70" r={gaugeRadius}
                    fill="none"
                    stroke={themes.fuel.primaryGradient}
                    strokeWidth="10"
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeStart} // Start empty
                    transform="rotate(-90 100 70)" // Start from top
                    filter={themes.fuel.glowFilter}
                >
                    {/* Animate the fill */}
                    <animate
                        attributeName="strokeDashoffset"
                        from={strokeStart} // Empty
                        to={strokeEnd}     // Target (e.g., 85% full)
                        dur="2s"
                        begin="0.2s"
                        fill="freeze" // Keep filled state
                        keyTimes="0; 1"
                        values={`${strokeStart}; ${strokeEnd}`}
                        calcMode="spline" // Smoother fill
                        keySplines="0.4 0 0.2 1"
                    />
                </circle>

                {/* Center Percentage Text (Optional) - Animates after fill */}
                <text x="100" y="75" textAnchor="middle" fill={themes.fuel.accentColor} fontSize="18" fontWeight="bold" opacity="0">
                    85% {/* Static text, but you could animate the number too */}
                    <animate attributeName="opacity" from="0" to="1" dur="0.5s" begin="2.2s" fill="freeze" />
                </text>

                {/* Radiating Energy Pulses */}
                {[0, 1, 2].map(i => (
                    <circle key={i} cx="100" cy="70" r={gaugeRadius + 10} // Start just outside gauge
                        fill="none"
                        stroke={themes.fuel.secondaryColor}
                        strokeWidth="1.5"
                        opacity="0">
                        {/* Appear after gauge fills, pulse outwards and fade */}
                        <animate attributeName="r" from={gaugeRadius + 10} to={gaugeRadius + 40} dur="2.5s" begin={`${2.5 + i * 0.6}s`} repeatCount="indefinite" />
                        <animate attributeName="opacity" values="0; 0.6; 0" keyTimes="0; 0.2; 1" dur="2.5s" begin={`${2.5 + i * 0.6}s`} repeatCount="indefinite" />
                    </circle>
                ))}
            </g>
        </svg>
    );
};

// Make sure to export the new components
export default {
    FindItSVG,
    BuildItSVG, // Updated
    UseItSVG    // Updated
};